import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_GET_ALL_SUPERVISIORS,
  SUCCESS_GET_ALL_SUPERVISIORS,
  FAILURE_GET_ALL_SUPERVISIORS,
  LOADING_GET_ALL_SUPERVISIORS,
} = documentationActions;

function* getAllSupervisiors(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_ALL_SUPERVISIORS });
    const response = yield call(templateService.getAllSupervisiorsByDiscipline, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_SUPERVISIORS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_SUPERVISIORS, payload: error });
  }
}

function* getAllSupervisiorsSaga() {
  yield takeEvery(REQUEST_GET_ALL_SUPERVISIORS, getAllSupervisiors);
}

export default getAllSupervisiorsSaga;
